export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-01.9147553f.svg";